import {apiPost} from './api';

export default class ServicioSeguridad {
  static cambiarPass(_password){
    const data = {
      password: _password
    };
      return apiPost('/recibos/cambiarpassword',data);
  } 
  
}